/**
 * useUserResources — React binding for userResourcesStore.
 *
 * Returns the live resources/selection state plus the derived selectedResource.
 * The store is the single source of truth shared by ResourceRegistryRail and
 * ResourcesPage (Rails Phase 2 / DEV-1375).
 */
import { useMemo, useSyncExternalStore } from 'react';
import {
  subscribe,
  getSnapshot,
  type UserResourcesState,
} from '../Data/UserResources/userResourcesStore';
import type { UserResource } from '../Data/UserResources/userResourceTypes';

export interface UseUserResourcesResult extends UserResourcesState {
  /** The currently selected resource object (or null). */
  selectedResource: UserResource | null;
}

export function useUserResources(): UseUserResourcesResult {
  const state = useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
  const selectedResource = useMemo(
    () =>
      state.resources.find((r) => r.resource_guid === state.selectedResourceGuid) ||
      null,
    [state.resources, state.selectedResourceGuid],
  );
  return { ...state, selectedResource };
}

export default useUserResources;
